import React from 'react';
import './About.css';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-header">
          <h2 className="about-title">
             {t("About", "عني")} <span className="title-accent">{t("Shadi", "شادي")}</span>
          </h2>
          <p className="about-subtitle">{t("The Artist Behind the Portraits", "الفنان خلف البورتريهات")} </p>
        </div>

        <div className="about-content">
          {/* صورتك الشخصية */}
          <div className="about-image">
            <div className="image-frame">
              <img 
                src="/assets/shadi-profile.jpg" 
                alt="Shadi - Portrait Artist" 
                className="artist-portrait"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextElementSibling.style.display = 'flex';
                }}
              />
              <div className="portrait-fallback">
                <div className="fallback-content">
                  <span className="fallback-icon">👨‍🎨</span>
                  <span className="fallback-text">{t("Shadi", "شادي")}</span>
                </div>
              </div>
              
              {/* إطار فني */}
              <div className="artistic-frame"></div>
            </div>
            
            {/* علامة التوقيع */}
            <div className="signature">
              <span className="signature-text">{t("Shadi", "شادي")}</span>
              <span className="signature-line"></span>
            </div>
          </div>

          {/* المعلومات الشخصية */}
          <div className="about-info">
            <div className="bio-section">
              <h3 className="bio-title">{t("My Artistic Journey", "رحلتي الفنية")} </h3>
              <p className="bio-text">
                {t("As a", "ك")}  <strong>{t("classically trained musician", "موسيقي كلاسيكي")}</strong>{t("and", "و")} <strong> {t("self-taught artist", "فنان عصامي")} </strong>, 
                {t("Although I ve spent only 2 years perfecting the art of pencil portraiture. But My background in music gives me a unique sensitivity to rhythm, harmony,  and emotion—qualities I translate into every stroke of my pencil.", "رغم اني قد امضيت فقط  سنتين  في إتقان فن رسم البورتريه بالقلم الرصاص.الا أن خلفيتي الموسيقية تمنحني حساسية فريدة للإيقاع والتناغم،والعاطفة - وهي صفات أجسدها في كل ضربة قلم رصاص.")}
              </p>
              
              <p className="bio-text">
                {t("Each portrait is more than just a drawing; it's a", "كل بورتيه هو اكثر مجرد رسم , انه ")} 
                 <strong> {t("story captured in graphite ", "انه قصة مجسدة بالقلم الرصاص ")}  </strong>. 
                {t("From the subtle play of light and shadow to the intricate details that reveal personality, I strive to create pieces that resonate emotionally and stand the test of time. ", "من التلاعب الدقيق بالضوء والظل إلى التفاصيل المعقدة التي تكشف عن الشخصية، أسعى جاهدًا لخلق قطع فنية تلامس المشاعر وتصمد أمام اختبار الزمن.")} 
              </p>
            </div>

            {/* المهارات */}
            <div className="skills-section">
              <h4 className="skills-title"> {t("My Expertise", "خبرتي")}  </h4>
              <div className="skills-grid">
                <div className="skill-card">
                  <div className="skill-icon">✏️</div>
                  <div className="skill-content">
                    <h5>{t("Pencil Portraiture", "بورتريهات الرصاص")}  </h5>
                    <p> {t("Specialized in graphite pencil drawings with exceptional detail", "متخصص في الرسم بالقلم الرصاص مع تفاصيل استثنائية")} </p>
                  </div>
                </div>
                
                <div className="skill-card">
                  <div className="skill-icon">👁️</div>
                  <div className="skill-content">
                    <h5> {t("Character Capture", "التقاط الشخصية")}  </h5>
                    <p>  {t("Focus on capturing personality and emotion, not just likeness  ", "التركيز على التقاط وتحسيد المشاعر وليس فقط الملامح")}     </p>
                  </div>
                </div>
                
                <div className="skill-card">
                  <div className="skill-icon">🎨</div>
                  <div className="skill-content">
                    <h5> {t("Artistic Sensitivity", "الحساسية الفنية")} </h5>
                    <p> {t("Musician's ear translated to artist's eye for harmony and balance", "أذني الموسيقية تناغمت وانسجمت مع عين الفنان بتوازن وحس فني ")}     </p>
                  </div>
                </div>
              </div>
            </div>

            {/* روابط */}
            <div className="links-section">
              <h4 className="links-title"> {t("Connect With Me", "تواصل معي ")}  </h4>
              <div className="social-links">
                <a 
                  href="https://www.youtube.com/@ShadiArts" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link youtube-link"
                >
                  <span className="link-icon">📺</span>
                  <span className="link-text">  {t("YouTube Channel", "قناتي على اليوتيوب")}  </span>
                  <span className="link-arrow">→</span>
                </a>
                
                <a 
                  href="https://wa.me/201151638804" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link whatsapp-link"
                >
                  <span className="link-icon">💬</span>
                  <span className="link-text"> {t("WhatsApp Business", "حسابي على واتس اب بيزنس")}    </span>
                  <span className="link-arrow">→</span>
                </a>
                
                <a 
                  href="mailto:shadiarts.official@gmail.com" 
                  className="social-link email-link"
                >
                  <span className="link-icon">📧</span>
                  <span className="link-text"> {t("Email Consultation", "استشارة عبر البريد الالكتروني")}  </span>
                  <span className="link-arrow">→</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* علامة YouTube */}
        <div className="youtube-cta">
          <div className="cta-content">
            <div className="cta-icon">🎬</div>
            <div className="cta-text">
              <h4> {t("Watch My Creative Process on YouTube", "شاهدوا عملية إبداعي على يوتيوب")} </h4>
              <p>  {t("Subscribe to see time-lapses, tutorials, and portrait creation stories", "اشترك لمشاهدة مقاطع الفيديو بتقنية التصوير الزمني، والدروس التعليمية، وقصص إنشاء الصور الشخصية")}   </p>
            </div>
            <a 
              href="https://www.youtube.com/@ShadiArts" 
              target="_blank" 
              rel="noopener noreferrer"
              className="cta-button"
            >
              {t("Subscribe Now", "اشترك الان")} 
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;